jQuery(document).ready(function () {
    readMore();
    scrollTop();
    toggleBlockManualInternalLinking();
    toggleSearchform();
    wpmlLanguageSelectorRGAA();
    clickNavigationLinkWithoutHref();
    initNavigationBlockSlider();
    initBlockSlider();
    initAutoScrollPowergutSlider();
    initYithFilterCheckbox();
    initOpenButtonYithFilters();

    gsap.config({
        nullTargetWarn: false,
    });

    // Slider
    if (jQuery('.pgut-slider').length > 0) {
        jQuery('.pgut-slider .pgut-arrow').click(function () {
            scrollingLeft(jQuery(this));
        });
    }

    jQuery("a[target=_blank]").each(function () {
        if (jQuery(this).attr('aria-label')) {
            let currentLabel = jQuery(this).attr('aria-label');
            jQuery(this).attr('aria-label', currentLabel + " - Ouvre dans un nouvel onglet");
        } else {
            jQuery(this).attr('aria-label', "Ouvrir dans un nouvel onglet");
        }
    });

    // Vérifie si l'utilisateur est sur iOS Chrome pour changer le message PWA
    var isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    var isChromeIOS = /CriOS/.test(navigator.userAgent);
    if (isIOS && isChromeIOS) {
        // Remplace le message du Call to Action SuperPWA
        jQuery('.superpwa-cta-btn .superpwa-stky-blk h2').text(
            '⚠️ Sur iOS Chrome, l’installation n’est pas possible. ' +
            'Veuillez ouvrir ce site dans Safari.'
        );
        // (Optionnel) forcer l’affichage du CTA si le plugin le masque
        jQuery('.superpwa-cta-btn .superpwa-butn').hide();
    }
});

var counter_effect = false;
jQuery(window).scroll(function(){
    // Activer l'effet Compteur quand on arrive dessus
    if(jQuery('.pgut-counter__number').length > 0){
        var top_window = jQuery('.pgut-counter__number').offset().top - window.innerHeight;
        if(!counter_effect && jQuery(window).scrollTop() > top_window){
            counterEffect();
            counter_effect = true;
        }
    }
});


// Animation de compteur de chiffres
function counterEffect() {
    jQuery('.pgut-counter__number').each(function () {
        var $this = jQuery(this);
        var split_string = $this.text().split(",");
        // Pour les nombres à décimales
        // On coupe la chaine en 2 et on fait deux compteurs différents
        if(split_string.length > 1){
            $this.html("<span class='pgut-counter__number-part'>"+split_string[0]+"</span>,<span class='pgut-counter__number-part'>"+split_string[1]+"</span>");
            jQuery.each(split_string, function(i, $val){;
                $val = $this.find('.pgut-counter__number-part').eq(i).text();
                jQuery({ Counter: 0 }).animate({ Counter: $this.find('.pgut-counter__number-part').eq(i).text() }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        $this.find('.pgut-counter__number-part').eq(i).text(Math.ceil(now).toLocaleString('fr'));
                    }
                });
            });
        }
        else {
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    $this.text(Math.ceil(now).toLocaleString('fr'));
                }
            });
        }



    });
}

function initSortByPosts(){
    if(jQuery('#pgut-sort-by').length > 0){
        jQuery('#pgut-sort-by').on('change', function(){
            var sortValue = jQuery(this).val();
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the sort_by parameter
            params.set('sort_by', sortValue);

            // Reload the page with the updated query parameters
            window.location.href = currentUrl.pathname + '?' + params.toString();
        });
    }
}

function readMore(action = 'hide'){
    let elements =  jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this);
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}
function toggleBlockManualInternalLinking(){
    // Block Internal Linking - Ouvrir / Fermer les accordéons
    if(jQuery('.pgut-manual-internal-linking').length > 0){
        jQuery('.pgut-manual-internal-linking .pgut-manual-internal-linking__heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }
}

function toggleSearchform(){
    if(jQuery('.pgut-search').length > 0) {
        jQuery('.pgut-search__content').on('click keypress', function () {
            jQuery(this).parent().toggleClass('pgut-search__open');

            if(jQuery(this).parent().hasClass('pgut-search__open')){
                jQuery('#pgut-searchform > input[type="text"]').focus();
            }
        });

        jQuery('.pgut-search__content__opened .pgut-icon').on('click keypress', function () {
            jQuery(this).closest('.pgut-search').toggleClass('pgut-search__open');
        });
    }
}

// Scroll to left or right inside an element
    function scrollingLeft(element_arrow) {
        var pgut_slider = element_arrow.closest('.pgut-slider');
        var $container = pgut_slider.find('.acf-innerblocks-container, .pgut-slider__container').first();
        var $current_slide = pgut_slider.find('.current-slide');
        
        // Si pas de slide actuelle, utiliser la première
        if($current_slide.length === 0){
            $current_slide = pgut_slider.find('.pgut-slide').first();
            $current_slide.addClass('current-slide');
        }
        
        // Calculer la largeur de défilement en utilisant la slide ACTUELLE (pas la première trouvée)
        var width_scroll;
        if(pgut_slider.hasClass('wp-block-powergut-slider')){
            // Pour wp-block-powergut-slider, utiliser la largeur de la slide actuelle
            width_scroll = $current_slide.width();
        } else {
            // Pour les autres sliders, utiliser la largeur + le gap
            // Le gap est généralement de 15px selon le CSS, mais on peut le calculer dynamiquement
            var slide_width = $current_slide.width();
            var slide_margin_right = parseInt($current_slide.css('margin-right')) || 0;
            var gap = 15; // Gap par défaut du CSS
            width_scroll = slide_width + slide_margin_right + gap;
        }
        
        var scroll_left = 0;
        if(element_arrow.hasClass('pgut-arrow-left')){
            scroll_left = "-="+width_scroll+"px";
        } else {
            scroll_left = "+="+width_scroll+"px";
        }
        
        // Animer le scroll
        $container.animate({
            scrollLeft: scroll_left
        }, "slow");
        
        // Animer aussi l'autre conteneur si présent
        var $other_container = pgut_slider.find('.acf-innerblocks-container, .pgut-slider__container').not($container);
        if($other_container.length > 0){
            $other_container.animate({
                scrollLeft: scroll_left
            }, "slow");
        }
        
        // Mettre à jour la classe current-slide après l'animation
        setTimeout(function(){
            var $new_current;
            if(element_arrow.hasClass('pgut-arrow-left')){
                $new_current = $current_slide.prev('.pgut-slide');
                if($new_current.length === 0){
                    $new_current = pgut_slider.find('.pgut-slide').last();
                }
            } else {
                $new_current = $current_slide.next('.pgut-slide');
                if($new_current.length === 0){
                    $new_current = pgut_slider.find('.pgut-slide').first();
                }
            }
            $current_slide.removeClass('current-slide');
            $new_current.addClass('current-slide');
            disableNavigationBlockSlider($new_current);
        }, 100);
    }

function wpmlLanguageSelectorRGAA(){
    // Sélectionner le bouton qui déclenche l'ouverture du sélecteur
    var dropdownToggle = document.querySelector('.wpml-ls-dropdown .wp-block-navigation-item__content');

    if (dropdownToggle) {
        // Rendre l'élément focusable
        dropdownToggle.setAttribute('tabindex', '0');

        // Écouter l'événement clavier (keydown)
        dropdownToggle.addEventListener('keydown', function(event) {
            // Vérifier si la touche est "Entrée" ou "Espace"
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Empêche un défilement involontaire par la touche Espace
                // Simuler le clic qui déclenche l'ouverture/fermeture du dropdown
                dropdownToggle.click();
            }
        });
    }
}

function clickNavigationLinkWithoutHref(){
    if(jQuery('header .wp-block-navigation__responsive-container-content .wp-block-navigation-item > a[href="#"]').length > 0){
        jQuery('header .wp-block-navigation__responsive-container-content .wp-block-navigation-item > a[href="#"]').click(function(e){
            e.preventDefault();
            var $button_to_submenu = jQuery(this).parent().find('button');
            if($button_to_submenu.attr('aria-expanded') === "false"){
                $button_to_submenu.attr('aria-expanded', true);
            }
            else {
                $button_to_submenu.attr('aria-expanded', false);
            }
        });
    }
}

function scrollTop(){
    jQuery('.pgut-scroll-top').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });
}

function initBlockSlider(){
    if(jQuery(".pgut-slider").length > 0){
        jQuery('.pgut-slider').each(function () {
            var $slides = jQuery(this).find('.pgut-slide');
            if($slides.length <= 1){
                jQuery(this).find('.pgut-slider__navigation').addClass('hide');
            }
            $slides.each(function ($index, $slide) {
                if($index == 0){
                    jQuery(this).addClass('current-slide');
                    disableNavigationBlockSlider(jQuery(this));
                }
            });

            // For accessibility, if enter si trigger click
            jQuery('.pgut-slider .pgut-arrow').keypress(function (e) {
                 var key = e.which;
                 if(key == 13)  // the enter key code
                  {
                    jQuery('.pgut-slider .pgut-arrow').click();
                    return false;
                  }
            });
        });
    }
}

function initNavigationBlockSlider(){
    if(jQuery(".pgut-slider.pgut-slider__add-navigation").length > 0){
        jQuery(".pgut-slider.pgut-slider__add-navigation").each(function(){
            jQuery(this).append("<div class=\"pgut-slider__navigation pgut__d__flex pgut-flex__ai__center pgut-flex__jc__center\"><div class=\"pgut-slider__prev pgut-arrow pgut-arrow-left pgut-icon pgut-icon__powergut-icon-arrow-slider-left\" aria-label=\"Précédent\" tabindex=\"0\"></div><div class=\"pgut-slider__next pgut-arrow pgut-arrow-right pgut-icon pgut-icon__powergut-icon-arrow-slider-right\"  aria-label=\"Suivant\" tabindex=\"0\"></div></div>");

            jQuery(this).find('.wc-block-product').each(function(){
                jQuery(this).addClass('pgut-slide');
            })
        });
    }
}

function initAutoScrollPowergutSlider(){
    // Cibler uniquement les blocs .wp-block-powergut-slider
    if(jQuery(".wp-block-powergut-slider").length > 0){
        jQuery('.wp-block-powergut-slider').each(function(){
            var $slider = jQuery(this);
            var $slides = $slider.find('.pgut-slide');
            
            // Ne pas activer le défilement automatique s'il n'y a qu'une seule slide
            if($slides.length <= 1){
                return;
            }
            
            var autoScrollInterval = null;
            var restartTimeout = null;
            
            // Fonction pour arrêter proprement le défilement automatique
            function stopAutoScroll(){
                if(autoScrollInterval){
                    clearInterval(autoScrollInterval);
                    autoScrollInterval = null;
                }
                if(restartTimeout){
                    clearTimeout(restartTimeout);
                    restartTimeout = null;
                }
            }
            
            // Fonction pour démarrer le défilement automatique
            function startAutoScroll(){
                // S'assurer qu'il n'y a pas d'intervalle existant
                stopAutoScroll();
                autoScrollInterval = setInterval(goToNextSlide, 2800);
            }
            
            // Fonction pour passer à la slide suivante avec défilement visuel
            function goToNextSlide(){
                var $current_slide = $slider.find('.current-slide');
                var $next_slide = $current_slide.next('.pgut-slide');
                
                // Si on est à la dernière slide, retourner à la première
                if($next_slide.length === 0){
                    $next_slide = $slides.first();
                    // Réinitialiser le scroll au début
                    $slider.find('.acf-innerblocks-container').animate({
                        scrollLeft: 0
                    }, "slow");
                    $slider.find('.pgut-slider__container').animate({
                        scrollLeft: 0
                    }, "slow");
                } else {
                    // Calculer la largeur de défilement en utilisant la slide ACTUELLE
                    var slide_width = $current_slide.width();
                    var slide_margin_right = parseInt($current_slide.css('margin-right')) || 0;
                    var gap = 0; // Gap par défaut du CSS
                    var width_scroll = slide_width + slide_margin_right + gap;
                    
                    // Animer vers la position cible
                    $slider.find('.acf-innerblocks-container').animate({
                        scrollLeft: "+=" + width_scroll + "px"
                    }, "slow");
                    $slider.find('.pgut-slider__container').animate({
                        scrollLeft: "+=" + width_scroll + "px"
                    }, "slow");
                }
                
                // Changer de slide
                $current_slide.removeClass('current-slide');
                $next_slide.addClass('current-slide');
                disableNavigationBlockSlider($next_slide);
            }
            
            // Démarrer le défilement automatique toutes les 8s (2800ms)
            startAutoScroll();
            
            // Arrêter le défilement automatique au survol
            $slider.on('mouseenter', function(){
                stopAutoScroll();
            });
            
            // Reprendre le défilement automatique quand la souris quitte
            $slider.on('mouseleave', function(){
                startAutoScroll();
            });
            
            // Arrêter le défilement automatique lors d'une interaction manuelle
            $slider.find('.pgut-arrow').on('click', function(){
                stopAutoScroll();
                // Redémarrer après un délai pour permettre à l'utilisateur de naviguer manuellement
                restartTimeout = setTimeout(function(){
                    startAutoScroll();
                }, 2800);
            });
        });
    }
}

function disableNavigationBlockSlider($current_slide){
    $prev_slide = $current_slide.parents('.pgut-slider').first().find('.current-slide').prev();
    if($prev_slide.length < 1){
        $current_slide.closest('.pgut-slider').first().find('.pgut-slider__prev').first().addClass('pgut-disabled');
    }
    else {
        $current_slide.closest('.pgut-slider').first().find('.pgut-slider__prev').first().removeClass('pgut-disabled');
    }

    $next_slide = $current_slide.parents('.pgut-slider').first().find('.current-slide').next();
    if($next_slide.length < 1){
        $current_slide.closest('.pgut-slider').first().find('.pgut-slider__next').first().addClass('pgut-disabled');
    }
    else {
        $current_slide.closest('.pgut-slider').first().find('.pgut-slider__next').first().removeClass('pgut-disabled');
    }
}

function initYithFilterCheckbox(){
    if(jQuery('.yith-wcan-filters').length > 0){
        jQuery('.yith-wcan-filters').click(function(e){
            if(e.target.className == "filter-title"){
                e.target.parentElement.classList.toggle('open');
            }

            if(jQuery('.filter-item.active').length > 0){
                jQuery('.filter-item.active').parents('.yith-wcan-filter').addClass('open');
            }
        });
    }

    if(jQuery('.filter-item.active').length > 0){
        jQuery('.filter-item.active').parents('.yith-wcan-filter').addClass('open');
    }
}

function initOpenButtonYithFilters(){
    var $btn = jQuery('#toggle-filters');
    var $filters = jQuery('.yith-wcan-filters');
    var $overlay = jQuery('#yith-filters-overlay');

    // Accessibilité : définir des rôles ARIA
    $filters.attr({
        'id': 'yith-filters-panel',
        'role': 'region',
        'aria-label': 'Filtres produits',
        'tabindex': '-1'
    });

    if ($btn.length && $filters.length) {
        $btn.on('click', function() {
            var isOpen = $filters.hasClass('open');
            $filters.toggleClass('open');
            $overlay.prop('hidden', isOpen);
            $btn.attr('aria-expanded', !isOpen);
            jQuery('body').toggleClass('filters-open', !isOpen);

            if (!isOpen) {
                $filters.attr('tabindex', '-1').focus();
                $btn.text('Fermer les filtres');
            } else {
                $btn.focus();
                $btn.text('Filtres');
            }
        });

        // Fermer avec la touche Échap
        jQuery(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $filters.hasClass('open')) {
                $filters.removeClass('open');
                $overlay.prop('hidden', true);
                $btn.attr('aria-expanded', 'false').focus();
                jQuery('body').removeClass('filters-open');
                $btn.text('Filtres');
            }
        });

        // Fermer après clic sur un lien de filtre
        $filters.find('a').on('click', function() {
            $filters.removeClass('open');
            $overlay.prop('hidden', true);
            $btn.attr('aria-expanded', 'false');
            jQuery('body').removeClass('filters-open');
            $btn.text('Filtres');
        });

        // Fermer en cliquant sur l’overlay
        $overlay.on('click', function() {
            $filters.removeClass('open');
            $overlay.prop('hidden', true);
            $btn.attr('aria-expanded', 'false').focus();
            jQuery('body').removeClass('filters-open');
            $btn.text('Filtres');
        });
    }
}